import { useParams } from 'react-router-dom';

import UsersOverview from '../../features/users/layouts/overview';
import CreateUserForm from '../../features/users/forms/create';
import EditUserForm from '../../features/users/forms/edit';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/users      → the list
//   /admin/users/new  → the create form, via `mode` (static route, no param)
//   /admin/users/:id  → the edit form
//
// `id === 'new'` is also checked, so this keeps working if the static route is
// ever dropped and the :id one starts catching that URL.

export default function UsersPage({ mode }) {
    const { id } = useParams();

    if (mode === 'create' || id === 'new') return <CreateUserForm />;
    if (id) return <EditUserForm userId={id} />;
    return <UsersOverview />;
}
